let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7B3CL")).then(() => parcelRequire('3i2SZ'));